import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = {
  width: "100",
  filter: "createdOn",
  filterType: "date",
  filterFrom: "inizioFrom",
  filterTo: "inizioTo",
  sort: "createdOn"
}
const _hoisted_3 = {
  width: "100",
  filter: "cliente",
  sort: "cliente.name"
}
const _hoisted_4 = {
  width: "100",
  filter: "centroFumo",
  sort: "centroFumo.name"
}
const _hoisted_5 = {
  width: "100",
  filter: "product",
  sort: "product.name"
}
const _hoisted_6 = {
  width: "100",
  filter: "usedOn",
  filterType: "date",
  filterFrom: "usedFrom",
  filterTo: "usedTo",
  sort: "createdOn"
}
const _hoisted_7 = { width: "100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { width: "100" }, null, -1)
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Voucher di prenotazione",
          text: "Voucher di prenotazione"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.caricaTicketModal && _ctx.caricaTicketModal(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Carica ticket",
          text: "Carica ticket"
        })
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cliente",
                text: "Cliente"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Centro fumo",
                text: "Centro fumo"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Prodotto",
                text: "Prodotto"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data utilizzo",
                text: "Data utilizzo"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Prenotazione identifier",
                text: "Prenotazione identifier"
              })
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.TicketPrenotazione[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
              _createElementVNode("td", null, _toDisplayString(item.cliente && item.cliente.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.centroFumo && item.centroFumo.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.product && item.product.name), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.usedOn, "yyyy-MMM-DD HH:mm")), 1),
              _createElementVNode("td", null, _toDisplayString(item.prenotazioneIdentifier), 1),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: ($event: any) => (_ctx.remove(item))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Cancella ticket da db",
                    text: "Cancella ticket da db"
                  })
                ], 8, _hoisted_9)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}